import { render } from "./ChannelComponent.vue?vue&type=template&id=4016f9c3"
import script from "./ChannelComponent.vue?vue&type=script&lang=js"
export * from "./ChannelComponent.vue?vue&type=script&lang=js"

import "./ChannelComponent.vue?vue&type=style&index=0&id=4016f9c3&lang=css"

import exportComponent from "/Users/ayarmots/MyDev/youtest.ru/youtest-front-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__